import { useEffect } from "react";
import { getActiveLiveContent } from "../utils/shared/events";
import { useEvents } from "../context/EventsContext";

const useActiveLiveContentSync = () => {
    const { setActiveEventData } = useEvents();

    useEffect(() => {
        const handleLiveContentUpdate = () => {
            setActiveEventData(prev => {
                const next = getActiveLiveContent() || {};
                if (prev === null) return next;
                if (prev?.id === next?.id && prev?.contentType === next?.contentType && prev?.status === next?.status) return prev;
                return next;
            });
        };

        window.addEventListener("LiveContentUpdate", handleLiveContentUpdate);
        return () => window.removeEventListener("LiveContentUpdate", handleLiveContentUpdate);
    }, [setActiveEventData]);
};

export default useActiveLiveContentSync;
